import { stylesheet } from 'typestyle';
import { flexRoot, horizontal, wrap, flexStart } from 'csstips';
import { regularYellowText, regularGrayText } from '@styles/general';

export default stylesheet({
  container: {
    marginTop: 40,
    paddingBottom: 10
  },
  list: {
    ...flexRoot,
    ...horizontal,
    ...wrap
  },
  title: {
    color: regularGrayText,
    fontWeight: 600
  },
  listItem: {
    ...flexRoot,
    ...flexStart,

    color: regularYellowText,
    fontSize: 14,
    lineHeight: '16px',
    marginTop: 10,
    width: 'calc((100% - 10px) / 2)',

    $nest: {
      '&:nth-child(2n+2)': {
        marginLeft: 10
      }
    },

    img: {
      marginRight: 10,
      width: 18
    },
    a: {
      color: regularGrayText,
      fontSize: 14,
      lineHeight: '16px',
      textDecoration: 'underline'
    }
  }
});
